import { useContext, useEffect, useState } from "react";
import "./style.css";
import FileUpload from "../../components/FileUpload";

import { getPendientes } from "../../context/actions/movCajaMedico/getPendientes";
import { GlobalContext } from "../../context/Provider";
import TableComponent from "../../components/TableComponent";
import LoadingComponent from "../../components/Loading";
import { Button } from "semantic-ui-react";

import { tableHeadersData } from "./tableHeadersData";
import { fileUpdateIconStatesData } from "./fileUpdateIconStatesData";

import postPendientes from "../../context/actions/movCajaMedico/postPendientes";

const tableHeaders = tableHeadersData;
const fileUpdateIconStates = fileUpdateIconStatesData;

const Pendientes = () => {
  const { pendienteDispatch, pendienteState } = useContext(GlobalContext);
  const [fileUpdateIconState, setFileUpdateIconState] = useState({});

  const [filesToPost, setFilesToPost] = useState({ profileImages: [] });
  const [base64Files, setBase64Files] = useState([]);

  const updateUploadedFiles = (files) => {
    //Al procesar completar subida de los archivos a la página proceso los mismos
    setFilesToPost({ ...filesToPost, profileImages: files });
    files.forEach(toBase64);
  };

  function toBase64(item) {
    //Paso los archivos a un string base64
    setBase64Files([]);
    return new Promise((resolve) => {
      let baseURL = "";
      let reader = new FileReader();
      reader.fileName = item.name;
      reader.readAsDataURL(item);

      reader.onload = () => {
        baseURL = reader.result;

        setBase64Files((old) => [
          ...old,
          baseURL.replace("data:application/pdf;base64,", ""),
        ]);
        resolve({ baseURL });
      };
    });
  }

  useEffect(() => {
    //Lo uso para procesar archivo Pdf.
    //cuando coincide los archivos pasados a base64 con los subidos entiendo que está listo para hacer el Post
    if (base64Files.length && filesToPost.profileImages.length) {
      if (base64Files.length === filesToPost.profileImages.length) {
        postPendientes(base64Files)(pendienteDispatch);
      }
    }
    // eslint-disable-next-line
  }, [base64Files]);

  useEffect(() => {
    //Leo los pendientes como proceso inicial
    getPendientes()(pendienteDispatch);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (pendienteState.pendientePost) {
      setFileUpdateIconState({});
      if (pendienteState.pendientePost.loading) {
        setFileUpdateIconState(fileUpdateIconStates[0]);
      } else if (
        pendienteState.pendientePost.data &&
        !pendienteState.pendientePost.error
      ) {
        setFileUpdateIconState(fileUpdateIconStates[1]);
      } else if (pendienteState.pendientePost.error !== null) {
        let iconState = fileUpdateIconStates[2];
        iconState.message = pendienteState.pendientePost.error.response.data;
        setFileUpdateIconState(iconState);
      }
    }

  }, [pendienteState]);

  return (
    <div className="wrap">
      <h4>
        Detalle de pacientes y montos por Ud. percibidos en DIM Centros de
        Diagnóstico, en los últimos 60 días.
      </h4>
      <small>
        Puede enviarles el recibo (RG. AFIP N° 4290/18) a través de este
        portal.
      </small>

      {pendienteState.pendiente.loading && <LoadingComponent />}

      {!pendienteState.pendiente.loading && !pendienteState.pendiente.error && (
        <div>
          <FileUpload
            labelFiles="Archivos de procesar"
            accept=".pdf"
            // multiple
            updateFilesCb={updateUploadedFiles}
            fileUpdateIconState={fileUpdateIconState}
          />
          {pendienteState.pendiente.data && (
            <TableComponent
              tableData={pendienteState.pendiente.data}
              tableHeaders={tableHeaders}
              tableFooters={true}
              striped
              sortable
              celled
            />
          )}
        </div>
      )}

      {!pendienteState.pendiente.loading && pendienteState.pendiente.error && (
        <div className="Error">
          <h1>
            Hubo un error al obtener los movimientos de caja del sistema. Por
            favor intente nuevamente
          </h1>
          <Button
            basic
            color="red"
            onClick={() => {
              getPendientes()(pendienteDispatch);
            }}
          >
            Reintentar
          </Button>
        </div>
      )}
    </div>
  );
};

export default Pendientes;
